import React from "react";

/**
 * Tooltip for the rollout / compliance pie charts.
 *
 * Lives at module scope and is shared rather than redefined inside each page
 * (S6478). Six byte-identical copies previously sat inside their parent
 * components, which meant Recharts saw a brand-new component type on every
 * parent render and remounted the tooltip each time.
 *
 * Pure by design — it reads only what Recharts passes in, so it needs no props
 * from the page that renders it. Used as `<Tooltip content={<PieValueTooltip />} />`.
 */
export function PieValueTooltip({ active, payload }) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-lg px-3 py-2 shadow text-sm">
      <span className="font-semibold" style={{ color: payload[0].payload.color }}>
        {payload[0].payload.label}
      </span>
      <span className="text-slate-700 ml-2">{payload[0].value} devices</span>
    </div>
  );
}
